import { Injectable } from '@angular/core';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class TovpilFilesService {

    constructor() { }

    /**
     * The function `tovpilExportXLSX` exports data to an XLSX file using the `xlsx` library in TypeScript.
     * @param {any[]} columnsValues - An array containing the values to be exported to the XLSX file. Each
     * element in the array represents a row in the worksheet, and the values within each element represent
     * the column values for that row.
     * @param {string} fileNameValue - The `fileNameValue` parameter is a string that represents the
     * desired name of the exported XLSX file.
     */
    async tovpilExportXLSX(columnsValues: any[], fileNameValue: string) {
        try {
            const xlsx = await import("xlsx");
            const worksheet = xlsx.utils.json_to_sheet(columnsValues);

            const date = new Date();
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const formattedDate = `${year}${month}${day}`;

            const filename = fileNameValue + `${formattedDate}.xlsx`;

            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            const data: Blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            });
            FileSaver.saveAs(data, filename);

        } catch (error) {
            console.error("Error exporting to XLSX:", error);
        }
    }

    /**
     * The function `tovpilExportPDF` exports data to a PDF file using the provided column names, column
     * values, and file name.
     * @param {string[]} columnsList - An array of strings representing the column names for the PDF table.
     * @param {any[]} columnsValues - The `columnsValues` parameter is an array of objects representing the
     * values for each column in the table. Each object in the array should have properties corresponding
     * to the column names in the `columnsList` parameter.
     * @param {string} fileNameValue - The fileNameValue parameter is a string that represents the desired
     * name of the exported PDF file.
     */

    async tovpilExportPDF(columnsList: string[], columnsValues: any[], fileNameValue: string) {
        let headerPDF: any[] = [columnsList];
        let data: any[] = columnsValues;

        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;

        const filename = fileNameValue + `${formattedDate}.pdf`;


        import("jspdf").then(jsPDF => {
            import("jspdf-autotable").then(x => {
                const doc = new jsPDF.default('landscape', 'cm', 'a4');
                autoTable(
                    doc, {
                    head: headerPDF,
                    body: data,
                    didDrawCell: (data) => {

                    },
                });
                doc.save(filename);
            })
        })
    }

}

